// File: src/Api/Axios.js
import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Add token to every request if available
api.interceptors.request.use((config) => {
  const token = Cookies.get('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


// Intercept all responses
api.interceptors.response.use(
  (response) => response, // ✅ Return if successful
  (error) => {
    if (error.response && error.response.status === 401) {
      // 🔐 Unauthorized — token expired or invalid
      Cookies.remove('token'); // Clear token if stored
      window.location.href = '/login'; // 🔁 Redirect to login page
    }
    return Promise.reject(error); // pass error along
  }
);

export default api;
